import { number, shape, string } from 'prop-types';
import React from 'react';
import {
  buildSizes,
  generateResolutionList,
  generateWidthList,
  isFixedSize
} from 'util/images/responsiveImages';

/**
 * handles rendering an individual <source> element for use within a <picture>.
 *
 * decides which approach to use for the srcSet based on if the provided image's
 * layoutWidth is specified in fixed vs. relative units.
 *
 */
function PictureSource(props) {
  const {
    url,
    media,
    imageDims: { width, height },
    layoutWidth,
    imgRenderOps
  } = props;

  const aspectRatio = width / height;

  // layoutWidths that are described in absolute/fixed units get
  // device-pixel-ratios; relative units get width descriptors, which need sizes
  const srcSet = isFixedSize(layoutWidth.units)
    ? generateResolutionList(url, imgRenderOps, layoutWidth.value, aspectRatio)
    : generateWidthList(url, imgRenderOps, width, aspectRatio);

  return (
    <source
      media={media}
      srcSet={srcSet}
      sizes={buildSizes([{ media, layoutWidth }])}
    />
  );
}

PictureSource.defaultProps = {
  imgRenderOps: {}
};

PictureSource.propTypes = {
  /** canonical image URL. used as basis for creating the DPR/width variations */
  url: string.isRequired,

  /** for doing image transforms */
  imgRenderOps: shape({}),

  /** media query for this source */
  media: string.isRequired,

  /** simple object representing width/height of the specified image */
  imageDims: shape({
    width: number,
    height: number
  }).isRequired,

  /** the layout width of the source. effectively coupled to the CSS. */
  layoutWidth: shape({
    value: number,
    units: string // CLEANUP: be more strict here as to the units via oneOf()
  }).isRequired
};

export default PictureSource;
